/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import {
  ICreateCampaign,
  ICreateTestCall,
  IUpdateCampaign,
} from "../models/campaign.model";

export const createCampaign = async (payload: ICreateCampaign) => {
  const res = await axios.post("/create_campaign", payload);
  return res;
};

export const deleteCampaign = async (id: string) => {
  const res = await axios.delete(`/delete_campaign/${id}`);
  return res;
};

export const uploadFile = async (file: File, agentId: string) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("agentId", agentId);
  const res = await axios.post("/create_audience_list", formData);
  return res;
};

export const getCampaigns = async (payload: {
  page: number;
  limit: number;
  keyword: string;
  status: string;
  directionFilter: string;
  sort?: Record<string, 1 | -1>;
}) => {
  const res = await axios.get("/view_campaigns", {
    params: {
      page: payload.page,
      limit: payload.limit,
      keyword: payload.keyword,
      status: payload.status,
      direction_filter: payload.directionFilter,
      sort: payload.sort,
    },
  });
  return res;
};

export const getCampaignById = async (id: string) => {
  const res = await axios.get(`/view_campaign_details`, {
    params: {
      campaign_id: id,
    },
  });
  return res;
};

export const updateCampaign = async (id: string, payload: IUpdateCampaign) => {
  const res = await axios.patch(`/update_campaign/${id}`, payload);
  return res;
};

export const getCampaignReport = async (
  campaignId?: string,
  agentId?: string,
  limit?: number,
  direction?: string
) => {
  const res = await axios.get(`/call_summary`, {
    params: {
      campaign_id: campaignId || "",
      agent_id: agentId || "",
      ...(limit ? { limit } : {}),
      ...(direction ? { direction } : {}),
    },
  });
  return res;
};

export const createTestCall = async (payload: ICreateTestCall) => {
  const res = await axios.post(`/call`, payload);
  return res;
};

export const getListAudiences = async () => {
  const res = await axios.get(`/list_audiences`);
  return res;
};

export const getPresignedAudioUrl = async (url: string | null, sid: string | null) => {
  const res = await axios.post("/call/download", {
    url: url,
    sid: sid,
  });
  return res;
};
